import "./RequestAQuote.module.css";
import Header from "@/reusable_sections/Header";
import HeroBookingForm from "./sections/HeroBookingForm";
import Footer from "@/reusable_sections/Footer";
export default function RequestAQuotePage() {
  return <div>
      <Header />
      <HeroBookingForm />
      <Footer />
    </div>;
}